import { jsxs as a, jsx as o } from "react/jsx-runtime";
import e from "./style.module.less.js";
import c from "./file.svg.js";
import m from "./cross-circle.svg.js";
import n from "./loading.svg.js";
const v = (l) => {
  const { filename: s, disabled: i, removeFile: r } = l;
  return /* @__PURE__ */ a(
    "button",
    {
      className: `${e.fileChip} ${i === !1 ? e.uploaded : ""}`,
      onClick: r,
      disabled: i,
      children: [
        /* @__PURE__ */ o("div", { className: e.folderIconContainer, children: /* @__PURE__ */ o(c, { className: e.folderIcon }) }),
        /* @__PURE__ */ o("div", { className: e.fileName, children: s }),
        /* @__PURE__ */ o(m, { className: e.crossCircleIcon }),
        i && /* @__PURE__ */ o("div", { className: e.loading, children: /* @__PURE__ */ o(n, { className: e.loadingIcon }) })
      ]
    }
  );
};
export {
  v as FileChip
};
